import { Alert20Regular, Info20Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const NotificationsOverviewPage = lazyPage(() => import('./tools/overview/pages/OverviewPage'));
const NotificationsDetailsPage = lazyPage(() => import('./tools/details/pages/DetailsPage'));

const notificationsModuleConfig = createModuleConfig({
  key: 'notifications',
  name: 'Notifications',
  domain: { title: 'Notifications', icon: Alert20Regular, shouldHide: true },
  tools: [
    { 
      key: 'overview',
      name: 'Overview',
      title: 'Notifications Overview',
      path: '/notifications', 
      element: <NotificationsOverviewPage />, 
      nav: { name: 'Overview', icon: Alert20Regular }
    },
    { 
      key: 'details',
      name: 'Details',
      title: 'Notification Details',
      path: '/notifications/details', 
      element: <NotificationsDetailsPage />, 
      nav: { name: 'Details', icon: Info20Regular }
    },
  ],
});

export default notificationsModuleConfig;
